import { environment } from '../../../environments/environment';
declare const grecaptcha: any;

export class Recaptcha {
    private static recaptchaKey = environment.CONSTANTS.RECAPTCHA_KEY;

    constructor() {}

    public static getToken(action: string): Promise<string> {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(this.recaptchaKey, { action })
                .then((token) => resolve(token))
                .catch(() => reject('Error al ejecutar recaptcha, por favor recargue la página'))
                // .finally(() => grecaptcha.reset());
            });
        });
    }
}
